// /creator-feature
import React from 'react';
import ProductPage from './ProductPage';
import creator_header from '../../assets/images/unauth/creator-feature-header.jpg';
import creator_poster from '../../assets/images/unauth/creator-feature-poster.jpg';
import creator_template from '../../assets/images/unauth/creator-feature-template.jpg';
import creator_preview from '../../assets/images/unauth/creator-feature-preview.jpg';

const StudioFeature = () => (
  <ProductPage
    path="/creator-feature"
    seo={{
      title: 'AI Automate Your Content Workflow | Bumpups.com',
      description: 'Elevate your video content creation with Bumpups Creator Studio. Upload videos, add AI-generated chapters to your YouTube descriptions, and publish or schedule to YouTube from one place.',
    }}
    hero={{
      title: 'Automate your content workflow',
      subtitle: 'Manage, optimize, and elevate your video content as a Bumpups Creator.',
      image: creator_header,
      imageAlt: 'A video in Creator Studio, ready to save or schedule to YouTube',
      width: 1400,
      height: 1087,
    }}
    marquee
    workflow={{
      title: 'Streamline your creative process',
      description: 'Transform how you manage and optimize your video content with advanced tools in Creator Studio, crafted for every Bumpups Creator.',
      video: '/media/creator-feature.mp4',
      poster: creator_poster,
      features: [
        { title: 'Post to YouTube', text: 'Upload your local video files into Creator Studio. Once uploaded, choose to save as a draft, mark as unlisted or public, or even schedule your video for later release on YouTube.' },
        { title: 'Description templates', text: 'Write your description once with the {{VIDEO_TIMESTAMPS}} variable, and Bump AI fills in the chapters it generates for every upload.' },
        { title: 'Preview generated description', text: 'Once Bump AI processes your video, the placeholders are replaced with actual content in the preview, so you can review and edit your description before finalizing it.' },
      ],
    }}
    rows={[
      {
        title: 'Chapters in every description',
        text: 'Add {{VIDEO_TIMESTAMPS}} to your description template and Bump AI fills in the chapters it generates for each video, so every upload is easy to navigate on YouTube.',
        cta: 'Try it out',
        image: creator_template,
        alt: 'A Creator Studio description template using the {{VIDEO_TIMESTAMPS}} variable',
      },
      {
        title: 'Preview the generated description',
        text: 'Once Bump AI processes your video, the placeholders are replaced with actual content in the preview. Review and edit it, then publish to YouTube as public, unlisted, or private, or schedule it for later.',
        cta: 'Try it out',
        image: creator_preview,
        alt: 'A description preview with its chapters filled in, beside the YouTube publish options',
      },
    ]}
  />
);

export default StudioFeature;
